import { DropdownContext, useDropdown } from '@mui/base';

import type { MenuProps } from './menu.types';

export default function Menu(props: React.PropsWithChildren<MenuProps>): JSX.Element {
  const { children, onOpenChange, open } = props;

  const { contextValue } = useDropdown({
    onOpenChange,
    open,
  });

  return <DropdownContext.Provider value={contextValue}>{children}</DropdownContext.Provider>;
}

Menu.displayName = 'Menu';
